





































































import { Component, Prop } from 'vue-property-decorator';
import FormRow from '@/components/common/forms/FormRow.vue';
import FormInput from '@/components/common/forms/FormInput.vue';
import FormInputPassword from '@/components/common/forms/FormInputPassword.vue';
import FormError from '@/components/common/forms/FormError.vue';
import { AdmiralForm } from '@/utils/AdmiralForm';
import FormInputMagicLink from '@/components/common/forms/FormInputMagicLink.vue';
import { ArrowDownIcon } from 'vue-feather-icons';

@Component({
  components: {
    FormInputMagicLink,
    FormError,
    FormInputPassword,
    FormInput,
    FormRow,
    ArrowDownIcon,
  },
})
export default class LoginForm<LoginModel, LoginDto> extends AdmiralForm {
  @Prop({ type: Boolean, default: false })
  magicLinkHint!: boolean;
}
